import Vue from 'vue'
import axios from 'axios'
import SmoothScroll from 'smooth-scroll'


Array.from(document.querySelectorAll('.static-map')).forEach(el => {
    new Vue({
    el,
    data() {
      return {
        loading: false,
        latitude: false,
        longitude: false,
        markers: [],
        options: {
          radius: 100,
          zoom: 12,
          scrollWheel: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          center: { lat: 39.8283, lng: -98.5795 },
          pinPath: '/wp-content/themes/bowtie/assets/images/',
          pinSize: [42, 42]
        }
      }
    },
    methods: {
      initMap() {
        this.map = new google.maps.Map(this.mapElement, {
          center: this.options.center,
          scrollwheel: this.options.scrollWheel,
          streetViewControl: this.options.streetViewControl,
          mapTypeControl: this.options.mapTypeControl,
          fullscreenControl: this.options.fullscreenControl,
          zoom: this.options.zoom,
          clickableIcons: false,
          disableDefaultUI: false
        })

        this.addMarker({ latitude: this.latitude, longitude: this.longitude })
        this.map.setCenter({ lat: this.latitude, lng: this.longitude })
      },
      addMarker(coords = {}, title = '') {
        let icon = {
          url: this.options.pinPath+'marker.svg',
          scaledSize: new google.maps.Size(32,44)
        }

        let marker = new google.maps.Marker({
          position: { lat: Number(coords.latitude), lng: Number(coords.longitude) },
          title,
          icon,
        })

        this.markers.push(marker)
        marker.setMap(this.map)
        return marker
      },
      directionURL(l) {
        return `https://www.google.com/maps/dir/Current+Location/${l.location.acf.address}%20${l.location.acf.address_2}%20${l.location.acf.city},%20${l.location.acf.state.label}%20${l.location.acf.zip}}`
      },
    },
    created() {
      
    },
    mounted() {
      this.latitude = Number(this.$el.getAttribute('data-latitude'))
      this.longitude = Number(this.$el.getAttribute('data-longitude'))

      this.mapElement = this.$el.querySelector('.map')
      this.initMap()
    }
  })
})